import isEmpty from 'lodash-es/isEmpty';
import { DateInputValue, partialDateFromString, MaybePartialDate } from '@tcl-argon-models/models';
import {
  decrementDateStringDay,
  decrementDateStringWeek,
  incrementDateStringDay,
  incrementDateStringWeek,
  todayDateString,
} from '@tcl-argon-utils/utils';

export interface UseCalendarKeyboardShortcutsParams {
  value: DateInputValue;
  onChange: (value: { dateString: string; dateObject: MaybePartialDate }) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dateParser?: (dateString: string) => MaybePartialDate;
}

enum CalendarAction {
  incrementDay,
  decrementDay,
  incrementWeek,
  decrementWeek,
  selectTodaysDate,
}

export function useCalendarKeyboardShortcuts({
  value,
  onChange,
  dateParser = partialDateFromString,
}: UseCalendarKeyboardShortcutsParams) {
  const reducer = (action: CalendarAction) => {
    let { dateString } = value;

    if (isEmpty(dateString)) {
      dateString = todayDateString();
    }

    let outputDateString = '';

    switch (action) {
      case CalendarAction.incrementDay:
        outputDateString = incrementDateStringDay(dateString);
        break;
      case CalendarAction.decrementDay:
        outputDateString = decrementDateStringDay(dateString);
        break;
      case CalendarAction.incrementWeek:
        outputDateString = incrementDateStringWeek(dateString);
        break;
      case CalendarAction.decrementWeek:
        outputDateString = decrementDateStringWeek(dateString);
        break;
      case CalendarAction.selectTodaysDate:
        outputDateString = todayDateString();
        break;
    }

    onChange({
      dateString: outputDateString,
      dateObject: dateParser(outputDateString),
    });
  };

  const handleDecrementDay = () => reducer(CalendarAction.decrementDay);
  const handleDecrementWeek = () => reducer(CalendarAction.decrementWeek);
  const handleIncrementDay = () => reducer(CalendarAction.incrementDay);
  const handleIncrementWeek = () => reducer(CalendarAction.incrementWeek);
  const handleSelectCurrentDate = () => reducer(CalendarAction.selectTodaysDate);

  return {
    handleDecrementDay,
    handleDecrementWeek,
    handleIncrementDay,
    handleIncrementWeek,
    handleSelectCurrentDate,
  };
}
